<template>
  <div>
    <div class="p-grid">
      <MatchDayClassList></MatchDayClassList>
    </div>
  </div>
</template>

<script>
import MatchDayClassList from "../components/MatchDayClassList";

export default {
  name: 'board-season-ranking',
  components: {
    MatchDayClassList
  },
  data() {
    return {
      content: '',
    };
  },
  mounted() {
    console.log("BoartdSeasonRanking mounted...");
  }
};
</script>